import React, { PureComponent } from "react";

import styles from "./Search.local.scss";
import SearchSelect from "./SearchSelect";
//import classnames from "classnames";
import _ from "i18n";

export default class SearchComponent extends PureComponent {
  render() {
    const {
      handleSelectArea,
      pellet,
      directory,
      dashboard,
      onClientSelected
    } = this.props;

    const allResourcesSelected = pellet && directory && dashboard; // TODO PowerTeam, dms ...
    let dropDownLabel = "";

    if (allResourcesSelected) {
      dropDownLabel = _("All resources");
    } else {
      const labels = [];
      if (pellet) {
        labels.push(_("Billtobox"));
      }

      if (directory) {
        labels.push(_("Directory"));
      }

      if (dashboard) {
        labels.push(_("Accounting"));
      }

      dropDownLabel = labels.join(", ");
    }

    return (
      <div className={styles.search}>
        <div className={styles.body}>
          <div className={styles.select}>
            <label>
              <span>{dropDownLabel}</span>
              <i className="icon icon-arrow-down" />
            </label>
            <ul>
              <li>
                <label htmlFor="pellet">
                  <input
                    type="checkbox"
                    id="pellet"
                    checked={pellet}
                    onChange={handleSelectArea.bind(this, "BILLTOBOX")}
                  />
                  {_("Billtobox")}
                </label>
              </li>
              <li>
                <label htmlFor="directory">
                  <input
                    type="checkbox"
                    id="directory"
                    checked={directory}
                    onChange={handleSelectArea.bind(this, "DIRECTORY")}
                  />
                  {_("Directory")}
                </label>
              </li>
              <li>
                <label htmlFor="accounting">
                  <input
                    type="checkbox"
                    id="accounting"
                    checked={dashboard}
                    onChange={handleSelectArea.bind(this, "DASHBOARD")}
                  />
                  {_("Accounting")}
                </label>
              </li>
              <li>
                <label htmlFor="powerteam">
                  <input type="checkbox" id="powerteam" disabled />
                  {_("Power team")}
                </label>
              </li>
              <li>
                <label htmlFor="dms">
                  <input type="checkbox" id="dms" disabled />
                  {_("DMS")}
                </label>
              </li>
            </ul>
          </div>
          <div className={styles.searchArea}>
            {/*}<input
              className={styles.text}
              type="text"
              placeholder={_("Search")}
              id="searchText"
            />*/}
            <SearchSelect onClientSelected={onClientSelected} />
            <div className={styles.submit}>
              <i className="icon icon-magnifier" />
              <span>{_("Search")}</span>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

// Conn



// WEBPACK FOOTER //
// ./src/components/Community/WorkPlace/Search/SearchComponent.js